<template>
  <section class="category-section">
    <div class="category-section__header">
      <h2 class="category-section__title">{{ title }}</h2>
      <span class="category-section__count">{{ count }} project{{ count !== 1 ? 's' : '' }}</span>
    </div>
    <div class="category-section__content">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CategorySection',
  props: {
    title: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
$primary: #2563eb;
$text-muted: #64748b;

.category-section {
  padding: 3rem 0;

  &__header {
    display: flex;
    align-items: baseline;
    gap: 1rem;
    margin-bottom: 2rem;
    padding-bottom: 0.5rem;
    border-bottom: 3px solid $primary;
  }

  &__title {
    text-transform: capitalize;
  }

  &__count {
    color: $text-muted;
    font-size: 0.9rem;
  }

  &__content {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .category-section {
    &__content {
      grid-template-columns: 1fr;
    }
  }
}
</style>
